export const NOTEPAD = {
  // Auth
  authPasswordInput: "auth-password-input",
  authSubmitBtn: "auth-submit-btn",
  authToggleMode: "auth-toggle-mode",
  authErrorMsg: "auth-error-msg",

  // App shell
  appShell: "app-shell",
  logoutBtn: "logout-btn",
  sidebar: "sidebar",
  sidebarToggle: "sidebar-toggle",
  newNoteBtn: "new-note-btn",
  sidebarNoteItem: (id) => `sidebar-note-${id}`,
  sidebarDeleteBtn: (id) => `sidebar-delete-${id}`,

  // Tab bar
  tabBar: "tab-bar",
  tab: (id) => `tab-${id}`,
  tabCloseBtn: (id) => `tab-close-${id}`,
  tabRenameInput: "tab-rename-input",

  // Editor
  editorContainer: "editor-container",
  editorCanvas: "editor-canvas",
  gutter: "gutter",
  gutterLine: (n) => `gutter-line-${n}`,
  bookmarkDot: (n) => `bookmark-dot-${n}`,
  copyLineBtn: (n) => `copy-line-${n}`,
  saveStatus: "save-status",

  // Toolbar
  stabiloBtn: (color) => `stabilo-${color}`,
  stabiloClearBtn: "stabilo-clear",

  // Find & Replace
  findReplaceToggle: "find-replace-toggle",
  findReplacePanel: "find-replace-panel",
  findInput: "find-input",
  replaceInput: "replace-input",
  findNextBtn: "find-next-btn",
  findPrevBtn: "find-prev-btn",
  replaceOneBtn: "replace-one-btn",
  replaceAllBtn: "replace-all-btn",
  findReplaceClose: "find-replace-close",
  findMatchCount: "find-match-count",
};
